import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddTechnician = forwardRef((props, ref) => {
    const [inviteModal, setInviteModal] = useState(false);

    // Using useImperativeHandle to expose the modal opening function
    useImperativeHandle(ref, () => ({
        showInviteModal() {
            setInviteModal(true);
        }
    }));

    // Form state
    const [formData, setFormData] = useState({
        FirstName: '',
        LastName: '',
        Specialization: '',
        HourlyRate: '',
        HireDate: '',
        Phone: '',
        Email: '',
        Salary: '',
        SalaryAmount: ''
    });

    const [errors, setErrors] = useState(null); // Handling errors

    // Handle form field change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    // Handle form submit
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const phone = formData.Phone ? String(formData.Phone) : '';

            if (!phone.match(/^(218)?09[123456][0-9]{7}$/)) {
                setErrors('رقم الهاتف  : 00 00 000 091 او 00 00 000 092');
                console.log(errors);
            } else {
                // Send POST request to the API
                const response = await axios.post('https://subk.education.com.ly/back/api/technicians', formData);
                toast.success('Technician added successfully!');
                console.log('Response:', response.data);
                props.parentFunction();
                setInviteModal(false); // Close modal on success
            }
        } catch (error) {
            console.error('There was an error submitting the form!', error);
            setErrors('Failed to submit technician data.');
            toast.error('Failed to submit technician data.');
        }
    };
    const [salaryType, setSalaryType] = useState("amount");
    const [salaryAmount, setSalaryAmount] = useState("");
    const [salaryPercentage, setSalaryPercentage] = useState("");
    return (
        <>
            <ToastContainer />
            <Modal className="modal fade" show={inviteModal} centered>
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel1">اضافة فني</h1>
                        <button
                            type="button"
                            className="btn-close"
                            style={{ marginLeft: 0 }}
                            onClick={() => setInviteModal(false)}
                        ></button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-xl-12">
                                    {errors && <div className="alert alert-danger">{errors}</div>}
                                </div>

                                <div className="col-xl-6">
                                    <label className="form-label mt-3">الاسم <span className="text-danger">*</span></label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="FirstName"
                                        value={formData.FirstName}
                                        onChange={handleChange}
                                        required
                                        pattern="[a-zA-Z\u0600-\u06FF\s]+"
                                        title="الرجاء إدخال أحرف فقط، الفراغات، والحروف العربية"
                                    />
                                </div>

                                <div className="col-xl-6">
                                    <label className="form-label mt-3">اللقب<span className="text-danger">*</span></label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="LastName"
                                        value={formData.LastName}
                                        onChange={handleChange}
                                        pattern="[a-zA-Z\u0600-\u06FF\s]+"
                                        title="الرجاء إدخال أحرف فقط، الفراغات، والحروف العربية"
                                    />
                                </div>

                                <div className="col-xl-6">
                                    <label className="form-label mt-3">التخصص <span className="text-danger">*</span></label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="Specialization"
                                        value={formData.Specialization}
                                        onChange={handleChange}

                                    />
                                </div>

                                <div className="col-xl-6">
                                    <label className="form-label mt-3">ساعات العمل <span className="text-danger">*</span></label>
                                    <input
                                        className="form-control"
                                        type="number"
                                        name="HourlyRate"
                                        value={formData.HourlyRate}
                                        onChange={handleChange}

                                    />
                                </div>

                                <div className="col-xl-6">
                                    <label className="form-label mt-3">تاريخ التعين <span className="text-danger">*</span></label>
                                    <input
                                        className="form-control"
                                        type="date"
                                        name="HireDate"
                                        value={formData.HireDate}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-xl-6">
                                    <label className="form-label mt-3">رقم الهاتف</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="Phone"
                                        value={formData.Phone}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-xl-12">
                                    <label className="form-label mt-3">البريد الالكتروني<span className="text-danger">*</span></label>
                                    <input
                                        className="form-control"
                                        type="email"
                                        name="Email"
                                        value={formData.Email}
                                        onChange={handleChange}
                                    />
                                </div>


                                <div lassName="col-xl-12 ">
                                    <label className="form-label m-3">
                                        <input

                                            type="radio"
                                            value="amount"
                                            checked={salaryType === "amount"}
                                            onChange={() => setSalaryType("amount")}
                                        />
                                        الراتب بالنسبة    </label>
                                    <label className="form-label m-3">
                                        <input
                                            type="radio"
                                             value="percentage"
                                            checked={salaryType === "percentage"}
                                            onChange={() => setSalaryType("percentage")}
                                        />
                                        الراتب التابت    </label>

                                    {salaryType === "amount" && (
                                        <input className="form-control"
                                            type="number"
                                             name="Salary"
                                            value={formData.Salary}
                                            onChange={handleChange}
                                        />
                                    )}

                                    {salaryType === "percentage" && (
                                        <input
                                            type="number" name="SalaryAmount"
                                           className="form-control"
                                             value={formData.SalaryAmount}
                                            onChange={handleChange}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="submit" className="btn btn-primary">حفظ</button>
                            <button
                                type="button"
                                className="btn btn-danger light"
                                onClick={() => setInviteModal(false)}
                            >
                                الغاء
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    );
});

export default AddTechnician;
